import { createContext, useContext } from 'react';
import { ContributorFeedbackStore } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ContributorFeedback/stores/useContributorFeedbackStore';
import { StoreApi, useStore } from 'zustand';

export const ContributorFeedbackStepContext = createContext<{
  stepWithIndexKey?: string;
} | null>(null);

export const ContributorFeedbackContext = createContext<StoreApi<ContributorFeedbackStore> | null>(
  null,
);

export function useContributorFeedbackContext<T>(
  selector: (state: ContributorFeedbackStore) => T,
): T {
  const store = useContext(ContributorFeedbackContext);
  if (!store) throw new Error('Missing ContributorFeedbackContext.Provider in the tree');
  return useStore(store, selector);
}
